<div>
  <div class="form-label" [ngClass]="{'text-muted': field.type == 'images' || field.type == 'files' }">
    <span>{{field.name}}</span>
    @if (field.description) {
      <span> - {{field.description}}</span>
    }
  </div>

  @switch (field.type) {
    <!-- Edit ChooseOne Type -->
    @case ('chooseOne') {
      <div class="input-group d-flex">
        <select [formControl]="value" class="form-select">
          @for (option of field.dropdownOptions; track option) {
            <option [value]="option">
              {{option}}
            </option>
          }
        </select>
      </div>
    }
    <!-- Edit ChooseMultiple Type -->
    @case ('chooseMultiple') {
      <div class="input-group d-flex">
        <select [formControl]="value" class="form-select" multiple>
          @for (option of field.dropdownOptions; track option) {
            <option [value]="option">
              {{option}}
            </option>
          }
        </select>
      </div>
    }
    <!-- Edit TrueFalse Type -->
    @case ('trueFalse') {
      <div class="btn-group d-flex bg-white">
        <input (click)="updateTrueFalse('True')" class="btn-check" [id]='"true-btn" + field.id' type="radio"
          value="True">
          <label class="btn btn-outline-success" [for]='"true-btn" + field.id'>True</label>
          <input (click)="updateTrueFalse('False')" class="btn-check" [id]="'false-btn' + field.id" type="radio"
            value="False">
            <label class="btn btn-outline-danger" [for]="'false-btn' + field.id">False</label>
          </div>
        }
        <!-- Edit Location Type -->
        @case ('location') {
          <div class="d-flex flex-column gap-2 w-100">
            <shared-mini-map [center]="{lng: field?.defaultValue?.[0], lat: field?.defaultValue?.[1]}" [zoom]="15"
              [markerLocations]="[{ location: {lng: value.value?.[0], lat: value.value?.[1]} }]"
              (mapClick)="handleMapClick($event)">
            </shared-mini-map>
            <div class="row g-3">
              <!-- Longitude -->
              <div class="col-md-6">
                <input type="number" [(ngModel)]="value.value[0]"
                  [ngClass]="{'is-invalid': value.value?.[0] != '' && !validLongitude && value.touched }"
                  class="form-control" (input)="updateLngLat($event.target.value, 0)" min="-180" max="180"
                  placeholder="Longitude" title="Longitude">
                  <div class="invalid-feedback">
                    Longitude must be between -180 and 180
                  </div>
                </div>
                <!-- Latitude -->
                <div class="col-md-6">
                  <input type="number" [(ngModel)]="value.value[1]"
                    [ngClass]="{'is-invalid': field.value?.[1] != '' && !validLatitude && value.touched }"
                    class="form-control" (input)="updateLngLat($event.target.value, 1)" min="-90" max="90"
                    placeholder="Latitude" title="Latitude">
                    <div class="invalid-feedback">
                      Latitude must be between -90 and 90
                    </div>
                  </div>
                </div>
              </div>
            }
            <!-- Edit Images Type -->
            @case ('images') {
              <hr>
              }
              <!-- Edit Files Type -->
              @case ('files') {
                <hr>
                }
                @default {
                  <div class="input-group d-flex">
                    <input [formControl]="value" class="form-control" [type]="field.type">
                  </div>
                }
              }
            </div>